export default "__VITE_ASSET__Djd3ER09__"